module.exports = __webpack_public_path__ + "static/img/user-02.5715028.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/user-02.png
// module id = 5rJs
// module chunks = 1